
export default {
  mounted() {
    this.$router.push('/')
  },
}
